// Theme toggle: dark (atelier default) <-> light, persisted across visits.
// No-JS fallback is out of scope: pages ship data-theme="dark" and stay there without JS.
const THEME_KEY = "portfolio-theme";
const root = document.documentElement;
const button = document.querySelector(".theme-toggle");

function stored() {
  try {
    const value = localStorage.getItem(THEME_KEY);
    if (value === "light" || value === "dark") return value;
  } catch (e) {
    /* storage unavailable — fall through to markup default */
  }
  return root.getAttribute("data-theme") === "light" ? "light" : "dark";
}

function render(theme) {
  root.setAttribute("data-theme", theme);
  const next = theme === "dark" ? "light" : "dark";
  if (button) button.setAttribute("aria-label", "Switch to " + next + " theme");
  if (button) button.textContent = theme === "dark" ? "Dark" : "Light";
}

render(stored());

if (button) {
  button.addEventListener("click", () => {
    const next = stored() === "dark" ? "light" : "dark";
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (e) {
      /* theme still applies for this visit via render() */
    }
    render(next);
  });
}
